import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=7a821b5e&"
import script from "./SaveIcon.vue?vue&type=script&lang=ts&"
export * from "./SaveIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports